import { ExternalUrlSectionType } from 'app/area/external-urls-administration/form/metroline/types';
import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ExternalUrlAdminState } from '../types-store';
import { hasChanges } from './utils/has-changes';

export interface ExternalUrlFormSelectorProps {
  id: number;
  shouldPrompt: boolean;
  section: ExternalUrlSectionType;
}

type ExternalUrlFormSelectors = { [T in keyof ExternalUrlFormSelectorProps]?:
  (state: ExternalUrlAdminState, props: DefaultContainerProps) => ExternalUrlFormSelectorProps[T] };

export const selectors: ExternalUrlFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.externalUrlItem, form?.originalExternalUrlItem),
  id: (_, { params }) => selectorId(params?.id),
  section: (_, { params }) =>
    params?.section || undefined
};
